<template>
  <div class="auth-wrapper">
    <!-- Loading state during auth initialization -->
    <div v-if="isInitializing" class="auth-loading">
      <v-overlay :value="true" color="primary" opacity="0.8">
        <div class="text-center">
          <v-progress-circular
            :size="60"
            :width="6"
            color="white"
            indeterminate
          ></v-progress-circular>
          <h3 class="white--text mt-4">{{ $t('auth.initializing') }}</h3>
          <p class="white--text mt-2">{{ $t('auth.initializingMessage') }}</p>
        </div>
      </v-overlay>
    </div>

    <!-- Main app content -->
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    name: "AuthWrapper",
    data() {
        return {
            isInitializing: true,
            authUnsubscribe: null
        };
    },
    async mounted() {
        await this.initializeAuth();
    },
    beforeDestroy() {
        if (this.authUnsubscribe) {
            this.authUnsubscribe();
        }
    },
    methods: {
        async initializeAuth() {
            try {
                // Initialize the auth service
                await this.$AuthService.initialize();

                // Set up auth state change listener
                this.authUnsubscribe = this.$AuthService.onAuthStateChanged((isAuthenticated) => {
                    // Update user in store when auth state changes
                    if (isAuthenticated) {
                        this.updateUserInStore();
                    }
                });

                // If we're on the auth callback page, don't hide loading
                // Let the callback page handle its own state
                if (this.$AuthService.isAuthCallback()) {
                    this.isInitializing = false;
                    return;
                }

                // Check if user is authenticated and update store
                const isAuthenticated = await this.$AuthService.isAuthenticated();
                if (isAuthenticated) {
                    await this.updateUserInStore();
                }

                this.isInitializing = false;
            } catch (error) {
                // Auth initialization error - suppressed for production
                this.isInitializing = false;
            }
        },

        async updateUserInStore() {
            try {
                const user = await this.$AuthService.getUser();
                if (user) {
                    // Cache user in session storage for performance
                    sessionStorage.setItem("auth.user", JSON.stringify(user));
                }
            } catch (error) {
                // Error updating user in store - suppressed for production
            }
        }
    }
};
</script>

<style scoped>
.auth-wrapper {
  min-height: 100vh;
}

.auth-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
</style>
